import { Container, Box, Typography } from "@mui/material";

import { useAccount } from "../../context/AccountProvider";
import { useSfs } from "../../context/SfsProvider";


const ArrangementInfoCard = () => {

  const { useGetAccount } = useAccount();
  const { account } = useGetAccount();

  const { disposableIncome } = useSfs();

  return (
    <Box
      sx={{
        borderRadius: 0,
        border: "1px solid lightgrey",
        pb: 3,
      }}
    >
      {/* Header section */}
      <Box
        sx={{
          pb: 1,
          borderBottom: "1px solid lightgrey",
          backgroundColor: "white",
        }}
      >
        <Container sx={{ width: "100%" }}>
          <Typography sx={{ fontSize: 20, fontWeight: "bold", py: 1 }}>
            Chase credit card
          </Typography>
        </Container>
      </Box>
      {/* End of header section */}

      <Box
        sx={{
          textAlign: "left",
          display: "flex",
          flexDirection: "column",
          pt: 1,
          pb: 2,
          px: 3,
        }}
      >
        <Typography
          component='label'
          htmlFor='balance'
          sx={{ fontSize: 13, py: 0.5 }}
        >
          Arrears balance
        </Typography>
        <Box
          id='balance'
          sx={{
            backgroundColor: "#E2E2E2",
            height: "34px",
            borderRadius: 0,
            border: "1px solid #BBBBBB",
            px: 1,
            py: 0.5,
            fontWeight: "bold",
            fontSize: 16,
          }}
        >
          {`£${account?.arrearsAmount?.toFixed(2)}`}
        </Box>

        <Typography
          component='label'
          htmlFor='disposable-income'
          sx={{ fontSize: 13, py: 0.5 }}
        >
          Disposable income
        </Typography>
        <Box
          id='disposable-income'
          sx={{
            backgroundColor: "#E2E2E2",
            color: disposableIncome > 0 ? "green" : "purple",
            height: "34px",
            borderRadius: 0,
            border: "1px solid #BBBBBB",
            px: 1,
            py: 0.5,
            fontWeight: "bold",
            fontSize: 16,
          }}
        >
          {`£${disposableIncome?.toFixed(2)}`}
        </Box>

      </Box>
    </Box>
  );
};

export default ArrangementInfoCard;
